/**
 * Image rules shared by the editor (`.rte-content`) and the User Guide reader
 * (`.user-guide-content`), so what an admin sizes is what a reader sees.
 *
 * The reader needs this more than the editor does: its article carries
 * `tw-prose` classes, but @tailwindcss/typography is not installed (see
 * tailwind.config.js), and preflight is off — so without these rules the page has
 * no img styling at all and a pasted screenshot overflows the column.
 *
 * Inline styles still win where the editor sets them: `applyImageWidth` writes
 * `width`, `applyImageAlign` writes `float`/`margin`, and `max-width: 100%` here
 * stays as the backstop that caps a legacy px width.
 */
export const contentImageCss = (scope) => `
  ${scope} img {
    max-width: 100%;
    height: auto;
    border-radius: 6px;
    margin: 0.4rem 0;
  }
  /* A floated image at the end of the content would otherwise escape its box. */
  ${scope}::after { content: ''; display: block; clear: both; }
  ${scope} h2 { clear: both; }
`;

export default contentImageCss;
